import React, { useState } from "react";
import { List, Empty } from "antd";
import { CompositeField } from "../../../../composite-field";
import { CourseModal } from "./modal";
import { CourseItem } from "./item";

export function CoursesInput({
  onChange,
  value,
  editable
}) {
  const [state, setState] = useState({
    isModalOpen: false,
    edit: false
  });

  const setModalVisibility = (visible = true) => {
    setState(prevState => ({
      ...prevState,
      isModalOpen: visible
    }));
  };

  const onEdit = (item, index) => () => {
    item.index = index;
    setState({ isModalOpen: true, edit: item });
  };

  const onSave = (addNew, replaceItemAtIndex) => values => {
    if (typeof values.index === "undefined") {
      addNew(values);
    } else {
      const index = values.index;
      delete values.index;

      replaceItemAtIndex(index, values);
    }
    setModalVisibility(false);
  };

  return (
    <CompositeField
      onChange={onChange}
      isAddDisabled={!editable}
      value={value}
      onClickAdd={() => setModalVisibility(true)}
      addLabel="Agregar curso o certificación">
      {({items, addNew, removeItem, replaceItemAtIndex}) =>
        <>
          <CourseModal
            onSave={onSave(addNew, replaceItemAtIndex)}
            onCancel={() => setModalVisibility(false)}
            visible={state.isModalOpen}
            edit={state.edit} />
          <List>
            { items.map((item, index) =>
              <CourseItem
                editable={editable}
                key={`course-item-${item.uuid}`}
                course={item}
                onDelete={removeItem(index)}
                onEdit={onEdit(item, index)} />
            ) }
            { (items.length === 0) ?
              <Empty />
            : null }
          </List>
        </>
      }
    </CompositeField>
  );
}
